"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Campaign = void 0;
const zod_1 = require("zod");
const ad_set_1 = require("./ad-set");
const entity_id_1 = require("./entity-id");
exports.Campaign = zod_1.z.object({
    /**
     * Unique id of the ad-set. Unset if the campaign was not yet stored.
     */
    id: entity_id_1.EntityId.optional(),
    /**
     * Names this campaign. If there are two campaigns with same name inside a CampaignList the list first one is ignored
     * ("last wins")
     *
     * TODO(roman): ID? globally unique?
     */
    name: zod_1.z.string().max(50),
    /**
     *
     */
    adSets: ad_set_1.AdSet.array(),
    // TODO: consider - createdAt, lastModifiedAt
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2FtcGFpZ24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvZW50aXRpZXMvY2FtcGFpZ24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsNkJBQXVCO0FBRXZCLHFDQUFnQztBQUNoQywyQ0FBc0M7QUFFekIsUUFBQSxRQUFRLEdBQUcsT0FBQyxDQUFDLE1BQU0sQ0FBQztJQUMvQjs7T0FFRztJQUNILEVBQUUsRUFBRSxvQkFBUSxDQUFDLFFBQVEsRUFBRTtJQUN2Qjs7Ozs7T0FLRztJQUNILElBQUksRUFBRSxPQUFDLENBQUMsTUFBTSxFQUFFLENBQUMsR0FBRyxDQUFDLEVBQUUsQ0FBQztJQUN4Qjs7T0FFRztJQUNILE1BQU0sRUFBRSxjQUFLLENBQUMsS0FBSyxFQUFFO0lBRXJCLDZDQUE2QztDQUM5QyxDQUFDLENBQUEifQ==